import { useOutletContext, useParams, useSearchParams } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'
import { isUndefined } from 'lodash'
import omitBy from 'lodash/omitBy'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import SaveModal, { SAVE_ACTION } from 'modules/reports/components/SaveReportModal'
import ReportsSqlEditor from 'modules/reports/components/SqlEditor'
import { useStoreSafe } from 'modules/reports/hooks/useStore'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'
import { PromptProvider } from 'modules/reports/lib/promptContext'
import Report from 'modules/reports/store/models/Report'

const SqlEditorNewPage = () => {
  const params = useParams()
  const [search, _] = useSearchParams()
  const { loading, dashboard } = useOutletContext<RouteContextParams>()

  const newReportAttrs = {
    chart_type: 'table',
    dashboard_id: Number(params.dashboard_id),
    dashboard: dashboard,
  }

  const report = new Report(omitBy(newReportAttrs, isUndefined))
  const { loading: isFeatureLoading, featureAvailability } = useFeatureAvailability(
    Features.analytics_advanced_reports
  )

  const store = useStoreSafe({
    report,
    origin: 'sql',
  })
  const isAuthorized = featureAvailability.available

  const showSaveModal = search.get('action') == SAVE_ACTION

  return (
    <ResponsivePage.Body
      error={undefined}
      loading={loading || isFeatureLoading}
      authorized={isAuthorized}
      showHeader={false}
    >
      <PromptProvider>
        {showSaveModal && report && store && <SaveModal report={report} store={store} />}
        <ReportsSqlEditor store={store} />
      </PromptProvider>
    </ResponsivePage.Body>
  )
}

export default SqlEditorNewPage
